import { CALL_API } from 'redux-api-middleware'
import { get, put } from 'utils/network'

export const getSimilarSubjects = offeringSubjectID => {
  const request = get(`/offerings/${offeringSubjectID}/similar`)
  request.types = [
    'CHSEC_REQ',
    {
      type: 'CHSEC_SUCC',
      meta: { offeringSubjectID },
    },
    'NOTIF_FAIL',
  ]
  return { [CALL_API]: request }
}

export const changeSection = (fr, to) => {
  const request = put('/offerings/change-section', {
    offering_subject_id: fr,
    to: to,
  })
  request.types = ['CHANGE_SEC_REQ', 'CHANGE_SEC_SUCC', 'CHANGE_SEC_FAIL']
  return { [CALL_API]: request }
}

export const changeSectionRevert = offeringSubjectID => {
  const request = put(`/offerings/change-section/${offeringSubjectID}/cancel`)
  request.types = ['CHANGE_SEC_REQ', 'CHANGE_SEC_SUCC', 'CHANGE_SEC_FAIL']
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/COR/hocs/withChangeSection/-actions.js